/**
 * Verbiage for the check-in submission hook.
 * Centralizes all user-facing messages for check-in operations.
 */
export const verbiage = {
  // ---- Error messages ----
  // Partial success messages (check-in succeeded, gallery failed)
  galleryUploadFailed: 'Image upload failed. The check-in was successful but all images could not be attached.',

  // Full failure messages
  imagePreparationFailed: 'Unable to prepare the selected images. Please remove and add them again.',
  checkInFailedNoId: 'Check-in failed: no ID returned.',
  checkInFailedDefault: 'Failed to check in. Please try again.',
};

